var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "anomaly-list" },
    [
      _vm._l(_vm.list, function (a, i) {
        return _c(
          "div",
          {
            key: a.uf + "-" + i,
            staticClass: "anomaly-item",
            class: _vm.severityCls(a.type),
          },
          [
            _c("div", { staticClass: "badge-uf" }, [_vm._v(_vm._s(a.uf))]),
            _c("div", { staticClass: "meta" }, [
              _c("div", { staticClass: "t1" }, [_vm._v(_vm._s(a.companyName))]),
              _c("div", { staticClass: "t2" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.reasonOf(a).zh)),
                  _c("span", { staticClass: "pt" }, [
                    _vm._v(" / " + _vm._s(_vm.reasonOf(a).pt)),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "right" }, [
              _c("span", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.fmtCheckTime(a.lastCheckTime))),
              ]),
            ]),
            _c(
              "a",
              {
                staticClass: "action",
                on: {
                  click: function ($event) {
                    return _vm.$emit("view", a)
                  },
                },
              },
              [
                _vm._v("查看 "),
                _c("span", { staticClass: "pt" }, [_vm._v(" / Ver ›")]),
              ]
            ),
          ]
        )
      }),
      !_vm.list.length
        ? _c("div", { staticClass: "empty" }, [
            _vm._v("暂无异常主体"),
            _c("span", { staticClass: "pt" }, [
              _vm._v(" / Nenhuma entidade com exceção"),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }